import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Button from '../../../shared/components/atoms/button/button'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import './sample-info-card.scss'

const SampleCardInfo = ({ content, openModal }) => {
  const data = useStaticQuery(graphql`
    {
      mobileBg: file(name: { eq: "bg-info-product" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      deskBg: file(name: { eq: "bg-info-product-desk" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const dataLayerTyC = () => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Terminos-Condiciones_VConfident',
      category: 'v-confident',
      action: 'click',
      label: 'Términos y Condiciones del muestreo',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  useEffect(() => {
    let link = document.querySelector('.f-terms-container a')
    link.setAttribute('target', '_blank')
    link.onclick = () => dataLayerTyC()
  }, [])

  return (
    <>
      <div className="f-sample-card-info">
        <GatsbyImage
          className="f-bg-image"
          objectFit="fill"
          alt="bg-image"
          image={withArtDirection(getImage(data.deskBg.childImageSharp), [
            {
              media: '(max-width: 960px)',
              image: getImage(data.mobileBg.childImageSharp),
            },
          ])}
        />

        <div className="f-sample-card-info__info">
          {documentToReactComponents(JSON.parse(content.informacionKit.raw))}
        </div>
        <GatsbyImage
          objectFit="contain"
          alt={content.imagenKit[0].description}
          image={getImage(content.imagenKit[0])}
          className="f-sample-card-info__image"
          alt="imagen producto  v-confident"
        />
        <div className="f-sample-card-info__seals">
          {content.sellosKit.map((sello, index) => (
            <img
              key={index}
              alt={sello.titulo}
              src={sello.imagenComponente[0].file.url}
              width={100}
              height={100}
            />
          ))}
        </div>
      </div>

      <div className="f-terms-container ">
        {documentToReactComponents(
          JSON.parse(content.textoTerminosYCondiciones.raw)
        )}
      </div>
    </>
  )
}

export default SampleCardInfo
